'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var culture = {
  'model': {

    'outdoorType': {
      'title': 'Sottomenù',
      'type': 'select',
      'enum': ['ARRAMPICATA', 'CANYONING', 'CIASPOLE', 'PROPOSTE_ESPERIENZIALI'],
      'prefix': 'vm.item.outdoor',
      'required': true
    },

    'title': {
      'title': 'Titolo',
      'type': 'input',
      'prefix': 'lang',
      'required': true
    },

    'municipality': {
      'title': 'Comune',
      'type': 'input',
      'prefix': 'vm.item.outdoor',
      'required': false
    },

    'category': {
      'title': 'Categoria',
      'type': 'input',
      'prefix': 'vm.item.outdoor',
      'required': false
    },

    'phoneNumber': {
      'title': 'Numero di telefono',
      'type': 'input',
      'prefix': 'vm.item.outdoor'
    },

    'eMail': {
      'title': 'E-mail',
      'type': 'input',
      'prefix': 'vm.item.outdoor'
    },

    'webSite': {
      'title': 'Sito web',
      'type': 'input',
      'prefix': 'vm.item.outdoor'
    },

    'description': {
      'title': 'Descrizione',
      'type': 'editor',
      'prefix': 'lang',
      'row': 8
    },

    'location': {
      'title': 'Ubicazione',
      'type': 'input',
      'prefix': 'lang',
      'required': true
    },

    'timetable': {
      'title': 'Orari e stagionalità',
      'type': 'input',
      'prefix': 'lang'
    },

    'note': {
      'title': 'Note',
      'type': 'editor',
      'prefix': 'lang',
      'row': 2
    },

    'additionalInformations': {
      'title': 'Approfondisci',
      'type': 'editor',
      'prefix': 'lang',
      'row': 2
    }
  }
};

exports.default = culture;


// WEBPACK FOOTER //
// ./client/app/common/factories/modelFactory/outdoor.model.js